
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.5","height":"23.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1028 -451)"}},[_c('path',{attrs:{"d":"M1039.75 451a11.75 11.75 0 11-11.75 11.75 11.75 11.75 0 0111.75-11.75z","fill":"#ea344b"}}),_c('path',{attrs:{"d":"M1039.75 455.1a7.65 7.65 0 11-7.65 7.65 7.65 7.65 0 017.65-7.65z","fill":"#fff","opacity":".211"}}),_c('rect',{attrs:{"width":"10","height":"10","transform":"translate(1034.78 457.78)","fill":"#fff"}})])])
          )
        }
      }
    